import { Fragment, ReactNode } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { GiPhone } from 'react-icons/gi';
import { Printer } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from '../Logo/Logo';
import { Button } from '../ui/button';

type Props = {
  children?: ReactNode;
};

const socialMedia = [
  { name: 'linkedin', icon: <FaLinkedinIn />, url: 'https://www.linkedin.com/company/hydreaulys ' },
];

const Footer = (props: Props) => (
  <Fragment>
    <div className="h-full bg-secondary">
      <div className="grid p-10 md:grid-cols-3 justify-items-center ">
        <div className="text-white">
          <div>
            <Logo />
          </div>
          <div>
            <p className="mt-4 text-white">
              Vous avez une question sur le service public de l'assainissement ?
            </p>
          </div>
          <div className="flex mt-4">
            {socialMedia.map((item, index) => (
              <div key={index} className="mr-4 text-white">
                <a href={item.url} target="_blank" rel="noreferrer">
                  {item.icon}
                </a>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center mt-5">
          <Link to="/contact" className="text-white m-14 ">
            <Button className="bg-white w-44 text-[#043f62] hover:text-white">
              Contactez-nous
            </Button>
          </Link>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <div>
            <p className="font-bold text-center text-white md:text-start">Liens utiles</p>

            <p className="mt-4 text-sm text-white">
              {' '}
              <a href="/questions">FAQ</a>
            </p>
            <p className="mt-4 text-sm text-white">
              <a href="/recrutement">Recrutement </a>
            </p>
            <p className="mt-4 text-sm text-white">
              {' '}
              <a href="/presse">Presse</a>
            </p>
            <p className="mt-4 text-sm text-white">
              {' '}
              <a href="/commande-publique">Marché publique </a>{' '}
            </p>
          </div>

          <div>
            <p className="font-bold text-center text-white md:text-start">Contact</p>
            <div className="flex mt-4 space-x-1">
              <GiPhone className="w-6 h-5 text-white" />
              <p className="text-sm text-white ">01 39 23 22 60</p>
            </div>
            <div className="flex mt-4 space-x-2">
              <FaLocationDot className="w-6 h-5 ml-1 text-white" />
              <p className="text-sm text-white ">12 rue Mansart – 78000 Versailles</p>
            </div>
          </div>
        </div>
      </div>
      <hr className="w-full " />
      <div className="pb-10">
        <div className="flex items-start justify-center mt-2 space-x-10">
          <p className="mt-4 text-sm text-white">
            {' '}
            <a href="/mentions-légales">Mentions légales </a>{' '}
          </p>
          <p className="mt-4 text-sm text-white">
            {' '}
            <a href="/politique-de-confidentialité">Politique de confidentialité</a>
          </p>
          <p className="mt-4 text-sm text-white">@ Hydreaulys 2024</p>
        </div>
      </div>
    </div>
  </Fragment>
);

export default Footer;
